import React from 'react';

import Typography from '../../../components/atoms/Typography';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const PanelSummary = ({ name }) => {
  return (
    <Typography component="p" variant="subTitleBold">
      <Text field={name} />
    </Typography>
  );
};

export default PanelSummary;
